// extracted by mini-css-extract-plugin
export default {"closed":"MenuIcon_closed__tM7Kw","opened":"MenuIcon_opened__O5Qxe","MenuIcon":"MenuIcon_MenuIcon__5wBUi"};